import React, { Component } from "react";
import PropTypes from "prop-types";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";

class WizardForm extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 1
    };
  }

  nextPage() {
    this.props.changeStep(2);
  }

  previousPage(event) {
    this.props.changeStep(1);
  }

  render() {
    const { onSubmit, actuallyStep } = this.props;

    let { page } = this.state;

    page = actuallyStep;

    return (
      <div>
        {page === 1 && <StepOne onSubmit={this.nextPage} />}
        {page === 2 && (
          <StepTwo
            changeData={this.props.changeData}
            data={this.props.data}
            onDelete={this.props.onDelete}
            changeType={this.props.changeType}
            type={this.props.type}
            previousPage={e => this.previousPage(e)}
            onSubmit={onSubmit}
          />
        )}
      </div>
    );
  }
}

export default WizardForm;

WizardForm.propTypes = {
  onSubmit: PropTypes.func.isRequired
};
